<template>
  <div
    class="modal-base-component app-modal-wrapper"
    :style="{ background: bgColor }"
  >
    <div class="mask" @click.self.stop="wrapperClick"></div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { setPageScroll } from '@/utils'
export default {
  props: {
    // 是否锁定页面滚动
    lockScroll: { type: Boolean, default: true },
    bgColor: { type: String, default: 'rgba(0, 0, 0, 0.65)' }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.lockScroll) {
        setPageScroll(false)
      }
    })
  },
  beforeDestroy() {
    setPageScroll(true)
  },
  methods: {
    wrapperClick() {
      this.$emit('wrapper-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-base-component {
  .mask {
    position: absolute;
    z-index: -999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
